import { render, staticRenderFns } from "./RulesList.vue?vue&type=template&id=62a04f7e&"
import script from "./RulesList.vue?vue&type=script&lang=js&"
export * from "./RulesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports